import React from 'react'
import { Line } from 'react-chartjs-2';
import { getDataSets, getLabels } from './graphsHelper';

export default function LineGraph(props) {
  const { title, graphData, wrapperClasses, tooltip, showLegend, customLabelData, customDataSets, customOptions } = props;

  const data = {
    labels: customLabelData ?? getLabels(props),
    datasets: customDataSets ?? (graphData && getDataSets(props))
  };

  const defaultOptions = {
    legend: {
      display: showLegend, // Hide the legend
    },
    scales: {
      yAxes: [
        {
          ticks: {
            maxTicksLimit: 10,
            beginAtZero: true,
            stepSize: 1,
          },
        },
      ],
    },
  };

  const options = customOptions
    ? { ...defaultOptions, ...customOptions, scales: { ...defaultOptions.scales, ...(customOptions.scales || {}) } }
    : defaultOptions;

  return (
    <div className={`${wrapperClasses}`}>
      <div className='bg-white p-3 border rounded mr-4'>
        <div className='d-flex justify-content-between px-5 pt-3'>
          <span className='font-size-18 mb-4'>{title}
            {tooltip && <span className="las la-info-circle text-primary ml-2 font-size-20 custom-tooltip z-index-2 p-2" data-title={tooltip}></span>}
          </span>
        </div>
        <Line data={data} options={options} />
      </div>
    </div>
  );
}
